<template>
  <sliderBarDialogShell
    ref="sliderbar"
    :dialog-show="dialogShow"
    :dialog-title="title"
    @close="beforeClose"
    @submit="confirm"
    :click-not-close="true"
    class="add-auth-dialog"
  >
    <auth-form
      :product-list="productList"
      :is-edit="false"
      ref="outform"
      @submit="submit"
    ></auth-form>
  </sliderBarDialogShell>
</template>

<script>
import authForm from "@/components/authorize/authForm";

import { addAuth } from "@/api/authorize";

export default {
  name: "addAuthDialog",
  components: {
    authForm,
  },
  props: {
    dialogShow: {
      type: Boolean,
      default: false,
    },
    productList: {
      type: Array,
      default(){
        return [];
      }
    },
  },

  data() {
    return {
      title: '新增授权码'
    }
  },
  methods: {
    beforeClose() {
      this.$emit('close');
      this.$refs.outform.selfClear();
    },
    cancel() {
      this.beforeClose();
    },
    confirm() {
      this.$refs.outform.selfValidate();
    },
    submit(form) {
      let params = {
        userName: form.name,
        phone: form.phone,
        authorizedProducts: form.productType.join(','),
        beginDate: form.startTime,
        endDate: form.endTime,
        type:form.type
      }
      if(form.recommender){
        params.referrer = form.recommender;
      }
      addAuth(params).then((data) => {
        if(data&&data.code&&data.code == 200){
          this.$message({
            message: '添加成功',
            type: 'success',
          });
          this.$refs.outform.selfClear();
          this.$emit('add-success');
        }else{
          this.$message.error(data.msg);
        }
      })
    }
  },
}
</script>

<style>
@media screen and (min-width: 768px) {
  .add-auth-dialog.sidebar-dialog .vs-sidebar {
    width: 800px;
  }
}

</style>
